import axios from "axios";
import {pushToast} from "../utils/pushToast";
import {useState} from "react";
var  changeForcePassword =false
const apiUrl = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_KEY : process.env.REACT_APP_DEV_API_KEY;

const client = axios.create({
    baseURL: apiUrl,
})

client.defaults.headers.common.Accept = 'application/json';
client.defaults.headers.common['Accept-Language'] = "fa";
client.defaults.headers.common['Content-Type'] = 'application/json';
client.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
client.interceptors.request.use(request => {
    if(changeForcePassword === false || request.url ==='User/ChangeUserPasswordByUser' || 'Authentication/Logout' || 'Authentication/LoginUser')
        return request;
    else
        window.location.replace("/change-password")

})

client.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response.status === 401) {
        removeToken();
        window.location.replace("/login")
    }
    if (error.response.status === 403) {
        pushToast("خطای دسترسی", "error")
    }
    return Promise.reject(error)
})

export const setToken = (token) => {
    localStorage.setItem('token', token);
    client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

const removeToken = () => {
    localStorage.removeItem('token');
    client.defaults.headers.common['Authorization'] = "";
}

export const login = async (values) => {
    client.defaults.headers.common['Authorization'] = ``;
    const {data} = await client.post(`Authentication/LoginUser`, values);
    if(data.userInfo.data.requiredChangePassword === true ){
        window.location.replace("/change-password")
        changeForcePassword= true
    }
    return data;
}

export const me = async () => {
    const {data} = await client.post(`User/UserInfo`);

    if(data.userInfo.data.requiredChangePassword === true ){
        changeForcePassword= true
    }
    return data;
}

export const logout = async (values) => {
    const {data} = await client.post(`Authentication/Logout`, values);
    removeToken();
    return data;
}

export const register = (values) => {
    const {data} = client.post(`Authentication/RegisterUser`, values);
    setToken(data.token);
    return data;
}

export const forgetPassword = (values) => {
    const {data} = client.post(`forget-password`, values);
    return data;
}

export const resetPassword = (values) => {
    const {data} = client.post(`Authentication/resetPassword`, values);
    return data;
}

export const verifyEmail = () => {
    const {data} = client.get(`verify-email`);
    return data;
}

export const ChangeUserPasswordByUser = async (values) => {
    const {data} = await client.post(`User/ChangeUserPasswordByUser`, values);
    if(data.status===200){
        changeForcePassword = false
    }
    return data;
}

export const ChangeUserPassword = async (id) => {
    const {data} = await client.get(`User/ChangeUserPassword/${id}`);
    if(data.status===200){
        changeForcePassword = false
    }
    return data;
}
export const ChangeActiveStatus = async (id) => {
    const {data} = await client.get(`User/ChangeActiveStatus/${id}`);
    if(data.status===200){
        changeForcePassword = false
    }
    return data;
}
// common

export const languages = async () => {
    const {data} = await client.get(`Common/GetListLanguage`);
    return data;
}

// User
export const users = async (values) => {
    const {data} = await client.post(`User/UserList`, values);
    return data;
}

export const user = async (id) => {
    const {data} = await client.get(`User/UserItem/${id}`);
    return data;
}

export const createUser = async (values) => {
    const {data} = await client.post(`User/AddNewUser`, values)
    return data;
}

export const updateUser = async (id, values) => {
    const {data} = await client.patch(`User/EditUser/${id}`, values)
    return data;
}
export const uploadExcelFile = async ( values) => {
    const {data} = await client.post(`User/UploadExcelFile`, values)
    return data;
}
export const deleteUser = async (id) => {
    const {data} = await client.post(`User/RemoveUser/${id}`)
    return data;
}

export const updateUserRole = async (values) => {
    const {data} = await client.patch(`User/UpdateUserRole`, values)
    return data;
}

// permission category

export const permissionCategories = async (values) => {
    const {data} = await client.post(`PermissionCategory/PermissionCategoryList`, values);
    return data;
}

export const permissionCategory = async (id) => {
    const {data} = await client.get(`PermissionCategory/PermissionCategoryItem/${id}`);
    return data;
}

export const createPermissionCategory = async (values) => {
    const {data} = await client.post(`PermissionCategory/AddPermissionCategory`, values);
    return data;
}

export const deletePermissionCategory = async (id) => {
    const {data} = await client.post(`PermissionCategory/RemovePermissionCategory/${id}`);
    return data;
}

export const updatePermissionCategory = async (id, values) => {
    const {data} = await client.patch(`PermissionCategory/EditPermissionCategory/${id}`, values);
    return data;
}

export const permissionCategoryList = async () => {
    const {data} = await client.get(`Permission/GetPermissionWithCategoryList`);
    return data;
}

// Role
export const roles = async (values) => {
    const {data} = await client.post(`Role/RoleList`, values);
    return data;
}

export const role = async (id) => {
    const {data} = await client.get(`Role/GetRoleItem/${id}`);
    return data;
}

export const createRole = async (values) => {
    const {data} = await client.post(`Role/AddRole`, values);
    return data;
}

export const deleteRole = async (id) => {
    const {data} = await client.post(`Role/RemoveRole/${id}`);
    return data;
}

export const updateRole = async (id, values) => {
    const {data} = await client.patch(`Role/EditRole/${id}`, values);
    return data;
}

export const updateRolePermission = async (values) => {
    const {data} = await client.patch(`Role/UpdateRolePermission`, values);
    return data;
}

//permission
export const permissions = async (values) => {
    const {data} = await client.post(`Permission/PermissionList`, values);
    return data;
}

export const permission = async (id) => {
    const {data} = await client.get(`Permission/GetPermissionItem/${id}`);
    return data;
}

export const createPermission = async (values) => {
    const {data} = await client.post(`Permission/AddPermission`, values)
    return data;
}

export const deletePermission = async (id) => {
    const {data} = await client.post(`Permission/RemovePermission/${id}`);
    return data;
}

export const updatePermission = async (id, values) => {
    const {data} = await client.patch(`Permission/EditPermission/${id}`, values);
    return data;
}
export const userJobAllItemList = async () => {
    const {data} = await client.get(`UserJob/UserJobAllItemList`);
    return data;
}
export const allUserCategories = async () => {
    const {data} = await client.post(`UserCategory/AllUserCategoryList`);
    return data;
}


//City

export const cities = async (values) => {
    const {data} = await client.post(`City/CityList`, values);
    return data;
}
export const city = async (id) => {
    const {data} = await client.get(`City/CityItem/${id}`);
    return data;
}
export const deleteCity = async (id) => {
    const {data} = await client.post(`City/RemoveCity/${id}`);
    return data;
}
export const createCity = async (values) => {
    const {data} = await client.post(`City/AddCity`, values);
    return data;
}
export const updateCity = async (id, values) => {
    const {data} = await client.patch(`City/EditCity/${id}`, values);
    return data;
}
export const GetAllCityList = async (id) => {
    const {data} = await client.get(`City/GetAllCityList/${id}`);
    return data;
}
//State

export const states = async (values) => {
    const {data} = await client.post(`State/StateList`, values);
    return data;
}
export const stateData = async (id) => {
    const {data} = await client.get(`State/StateItem/${id}`);
    return data;
}
export const deleteState = async (id) => {
    const {data} = await client.post(`State/RemoveState/${id}`);
    return data;
}
export const createState = async (values) => {
    const {data} = await client.post(`State/AddState`, values);
    return data;
}
export const updateState = async (id, values) => {
    const {data} = await client.patch(`State/EditState/${id}`, values);
    return data;
}
export const GetAllStateList = async () => {
    const {data} = await client.get(`State/GetAllStateList`);
    return data;
}



//ContentCategory
export const createContentCategory = async (values) => {
    const {data} = await client.post(`ContentCategory/AddContentCategory`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const updateContentCategory = async (id, values) => {
    const {data} = await client.patch(`ContentCategory/EditContentCategory/${id}`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const ContentCategoryList = async (values) => {
    const {data} = await client.post(`ContentCategory/ContentCategoryList`, values);
    return data;
}
export const ContentCategoryItem = async (id) => {
    const {data} = await client.get(`ContentCategory/ContentCategoryItem/${id}`);
    return data;
}
export const deleteContentCategory = async (id) => {
    const {data} = await client.post(`FrequentQuestion/RemoveFrequentQuestion/${id}`);
    return data;
}

export const AllContentCategories = async () => {
    const {data} = await client.get(`ContentCategory/AllContentCategories`);
    return data;
}

//Content
export const createContent = async (values) => {
    const {data} = await client.post(`Content/AddContent`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const updateContent = async (id, values) => {
    const {data} = await client.patch(`Content/EditContent/${id}`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const ContentList = async (values) => {
    const {data} = await client.post(`Content/ContentList`, values);
    return data;
}
export const ContentItem = async (id) => {
    const {data} = await client.get(`Content/ContentItem/${id}`);
    return data;
}
export const deleteContent = async (id) => {
    const {data} = await client.post(`Content/RemoveContent/${id}`);
    return data;
}


//Branch
export const createBranch = async (values) => {
    const {data} = await client.post(`Branch/AddBranch`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const updateBranch = async (id, values) => {
    const {data} = await client.patch(`Branch/EditBranch/${id}`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const BranchList = async (values) => {
    const {data} = await client.post(`Branch/BranchList`, values);
    return data;
}
export const BranchItem = async (id) => {
    const {data} = await client.get(`Branch/BranchItem/${id}`);
    return data;
}
export const deleteBranch = async (id) => {
    const {data} = await client.post(`Branch/RemoveBranch/${id}`);
    return data;
}


//productCategory
export const ProductCategoryList = async (values) => {
    const {data} = await client.post(`ProductCategory/ProductCategoryList`, values);
    return data;
}
export const AllProductCategoryList = async (values) => {
    const {data} = await client.get(`ProductCategory/AllProductCategories`, values);
    return data;
}
export const createProductCategory = async (values) => {
    const {data} = await client.post(`ProductCategory/AddProductCategory`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const updateProductCategory = async (id, values) => {
    const {data} = await client.patch(`ProductCategory/EditProductCategory/${id}`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const ProductCategoryItem = async (id) => {
    const {data} = await client.get(`ProductCategory/ProductCategoryItem/${id}`);
    return data;
}
export const deleteProductCategory = async (id) => {
    const {data} = await client.post(`ProductCategory/RemoveProductCategory/${id}`);
    return data;
}



//Product
export const createProduct = async (values) => {
    const {data} = await client.post(`Product/AddProduct`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const removeProductImage = async (id) => {
    const {data} = await client.get(`Product/RemoveProductImage/${id}`)
    return data;
}
export const updateProduct = async (id, values) => {
    const {data} = await client.patch(`Product/EditProduct/${id}`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const ProductList = async (values) => {
    const {data} = await client.post(`Product/ProductList`, values);
    return data;
}
export const ProductItem = async (id) => {
    const {data} = await client.get(`Product/ProductItem/${id}`);
    return data;
}
export const deleteProduct = async (id) => {
    const {data} = await client.post(`Product/RemoveProduct/${id}`);
    return data;
}
export const changeOrderProduct = async (value) => {
    const {data} = await client.post(`Product/ChangeOrderProduct/`,value);
    return data;
}



//Slider
export const createSlider = async (values) => {
    const {data} = await client.post(`Slider/AddSlider`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const updateSlider = async (id, values) => {
    const {data} = await client.patch(`Slider/EditSlider/${id}`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const sliderList = async (values) => {
    const {data} = await client.post(`Slider/SliderList`, values);
    return data;
}
export const sliderItem = async (id) => {
    const {data} = await client.get(`Slider/SliderItem/${id}`);
    return data;
}
export const deleteSlider = async (id) => {
    const {data} = await client.post(`Slider/RemoveSlider/${id}`);
    return data;
}
export const deleteContactUs = async (id) => {
    const {data} = await client.post(`ContactUs/RemoveContactUs/${id}`);
    return data;
}
export const deleteEmployment = async (id) => {
    const {data} = await client.post(`ContactUs/RemoveEmployment/${id}`);
    return data;
}
export const deleteRequestUsers = async (id) => {
    const {data} = await client.post(`BranchRequestUser/RemoveBranchRequestUsers/${id}`);
    return data;
}
export const deleteRequestBranch = async (id) => {
    const {data} = await client.post(`Branch/RemoveRequestBranch/${id}`);
    return data;
}



//FrequentQuestionCategory


export const FrequentQuestionCategoryList = async (values) => {
    const {data} = await client.post(`FrequentQuestionCategory/FrequentQuestionCategoryList`, values);
    return data;
}
export const AllFrequentQuestionCategoryList = async (values) => {
    const {data} = await client.get(`FrequentQuestionCategory/AllFrequentQuestionCategories`, values);
    return data;
}
export const createFrequentQuestionCategory = async (values) => {
    const {data} = await client.post(`FrequentQuestionCategory/AddFrequentQuestionCategory`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const updateFrequentQuestionCategory = async (id, values) => {
    const {data} = await client.patch(`FrequentQuestionCategory/EditFrequentQuestionCategory/${id}`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const FrequentQuestionCategoryItem = async (id) => {
    const {data} = await client.get(`FrequentQuestionCategory/FrequentQuestionCategoryItem/${id}`);
    return data;
}



//FrequentQuestion


export const FrequentQuestionList = async (values) => {
    const {data} = await client.post(`FrequentQuestion/FrequentQuestionList`, values);
    return data;
}

export const createFrequentQuestion = async (values) => {
    const {data} = await client.post(`FrequentQuestion/AddFrequentQuestion`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const updateFrequentQuestion = async (id, values) => {
    const {data} = await client.patch(`FrequentQuestion/EditFrequentQuestion/${id}`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const FrequentQuestionItem = async (id) => {
    const {data} = await client.get(`FrequentQuestion/FrequentQuestionItem/${id}`);
    return data;
}


///Basket
export const basketList = async (values) => {
    const {data} = await client.post(`Basket/BasketList`, values);
    return data;
}
export const kashmarBasketList = async (values) => {
    const {data} = await client.post(`Basket/KashmarBasketList`, values);
    return data;
}
export const confirmBasketList = async (values) => {
    const {data} = await client.post(`Basket/ConfirmBasketList`, values);
    return data;
}
export const basketItem = async (id) => {
    const {data} = await client.get(`Basket/BasketDetail/${id}`);
    return data;
}

export const contactUsList = async (values) => {
    const {data} = await client.post(`ContactUs/ContactUsList`, values);
    return data;
}
export const contactUsItem = async (id) => {
    const {data} = await client.get(`ContactUs/ContactUsItem/${id}`);
    return data;
}


export const createProductCity = async (values) => {
    const {data} = await client.post(`ProductCity/AddProductCity`,values);
    return data;
}
export const deleteProductCity = async (id) => {
    const {data} = await client.get(`ProductCity/RemoveProductCity/${id}`);
    return data;
}

export const ProductCityList = async (id,values) => {
    const {data} = await client.post(`ProductCity/ProductCityList/${id}`, values);
    return data;
}

export const requestBranch = async (values) => {
    const {data} = await client.post(`BranchRequestUser/GetBranchRequestUserList`, values);
    return data;
}
// export const sliderItem = async (id) => {
//     const {data} = await client.get(`Slider/SliderItem/${id}`);
//     return data;
// }
// export const deleteSlider = async (id) => {
//     const {data} = await client.post(`Slider/SliderCategory/${id}`);
//     return data;
// }


//BranchProduct

export const branchProductList = async (values) => {
    const {data} = await client.post(`BranchProduct/BranchProductList`, values);
    return data;
}
export const branchProduct = async (id) => {
    const {data} = await client.get(`BranchProduct/BranchProductItem/${id}`);
    return data;
}
export const deleteBranchProduct = async (id) => {
    const {data} = await client.post(`BranchProduct/RemoveBranchProduct/${id}`);
    return data;
}
export const createBranchProduct = async (values) => {
    const {data} = await client.post(`BranchProduct/AddBranchProduct`, values);
    return data;
}
export const updateBranchProduct = async (id, values) => {
    const {data} = await client.patch(`BranchProduct/EditBranchProduct/${id}`, values);
    return data;
}
export const branchBasketList = async (values) => {
    const {data} = await client.post(`BranchBasket/BranchBasketList`, values);
    return data;
}
//branchBasket
export const EmploymentListList = async (values) => {
    const {data} = await client.post(`ContactUs/EmploymentList`, values);
    return data;
}
export const branchBasket = async (id) => {
    const {data} = await client.get(`BranchBasket/BranchBasketItem/${id}`);
    return data;
}

export const BranchRequestList = async (values) => {
    const {data} = await client.post(`Branch/BranchRequestList`, values);
    return data;
}

export const ChangeBasketStatus = async (values) => {
    const {data} = await client.post(`Basket/ChangeBasketStatus`, values);
    return data;
}
export const BranchBasketStatusUnSend = async (id) => {
    const {data} = await client.patch(`BranchBasket/UpdateBranchBasketStatusToUnSend/${id}`);
    return data;
}
export const BranchBasketStatusSend = async (id) => {
    const {data} = await client.patch(`BranchBasket/UpdateBranchBasketStatusToSend/${id}`);
    return data;
}
